/**
 * Filas para el Excel de Gastos y compras.
 *
 * Puro a propósito: el botón de la página solo escribe el archivo. Así se puede
 * candar el formato (números sumables, vacíos sin inventar ceros, fecha Excel
 * sin desfase de zona) sin montar PagosTercerosPage.
 */
import { parseApiDateTime } from '../../../lib/helpers/datetime';

const COLUMNAS = [
  'Fecha',
  'Proveedor',
  'CIF',
  'Nº factura',
  'Concepto',
  'Grupo',
  'Estado',
  'Importe',
  'Base',
  'IVA %',
  'Cuota IVA',
];

/** Texto o vacío. Nunca null/undefined en la celda. */
function celdaTexto(value) {
  if (value == null) return '';
  const s = String(value).trim();
  return s;
}

/**
 * Número real para Excel, o vacío si el dato no viene.
 * No rellena con 0 un campo ausente (Base/IVA sin grabar ≠ 0 %).
 * Un 0 legítimo del API (p.ej. Importe 0) sí se conserva.
 */
function celdaNumero(value) {
  if (value == null || value === '') return '';
  const n = Number(value);
  return Number.isFinite(n) ? n : '';
}

/**
 * Fecha de Excel con el mismo reloj de pared que la tabla (hora local del club).
 * SheetJS serializa `Date` en UTC; reconstruir con getFullYear/getHours locales
 * evita el desfase de un día al abrir el archivo en España.
 */
function celdaFecha(value) {
  const parsed = parseApiDateTime(value);
  if (!parsed) return '';
  return new Date(
    parsed.getFullYear(),
    parsed.getMonth(),
    parsed.getDate(),
    parsed.getHours(),
    parsed.getMinutes(),
    parsed.getSeconds(),
  );
}

function estadoLegible(status) {
  return String(status || '').toLowerCase() === 'pendiente' ? 'Pendiente' : 'Pagada';
}

/**
 * @param {Array<object>} payments lista ya filtrada (la que pinta la tabla)
 * @returns {Array<object>} filas listas para `XLSX.utils.json_to_sheet`
 */
export function buildGastosExcelRows(payments) {
  if (!Array.isArray(payments) || payments.length === 0) return [];

  return payments.map((p) => ({
    Fecha: celdaFecha(p.paid_at),
    Proveedor: celdaTexto(p.supplier_name),
    CIF: celdaTexto(p.supplier_cif),
    'Nº factura': celdaTexto(p.invoice_number),
    Concepto: celdaTexto(p.concept),
    Grupo: celdaTexto(p.group_name),
    Estado: estadoLegible(p.status),
    Importe: celdaNumero(p.amount),
    Base: celdaNumero(p.base_ex_vat),
    'IVA %': celdaNumero(p.vat_rate),
    'Cuota IVA': celdaNumero(p.vat_amount),
  }));
}

/** `gastos-compras-AAAA-MM.xlsx` — monthIndex0 = 0…11 (como selectedMonth). */
export function gastosExcelFilename(year, monthIndex0) {
  const y = Number(year);
  const m = Number(monthIndex0) + 1;
  const mm = String(m).padStart(2, '0');
  return `gastos-compras-${y}-${mm}.xlsx`;
}

export const GASTOS_EXCEL_COLUMNAS = COLUMNAS;
